import { GenerateSlotsBaseInput, useMutateGenerateSlots } from '@@partner:graphql/mutation/slot/generateSlots.gql'
import AppLoader from '@components/common/AppLoader'
import React, {  useState } from 'react'
import { Button, ButtonGroup, Checkbox, Modal } from 'rsuite'

type props = Omit<GenerateSlotsBaseInput, 'replaceCreated'> & {
  open: boolean
  onClose: () => void
}

export default function GenerateSlotsModal ({
  zone_id,
  shop_id,
  open,
  onClose
}: props) {
  const [ replaceCreated, setReplaceCreated ] = useState(false)

  const [ generateSlots, { loading } ] = useMutateGenerateSlots()
  
  // reset state and close modal
  
  const handleSave = () => {
    generateSlots({
      variables: {
        zone_id,
        shop_id,
        replaceCreated
      }
    })
    onClose()
  }

  if (loading) {
    return <AppLoader content='Пересоздаем' />
  }

  return (
    <Modal 
      size='lg'
      overflow={true}
      open={open} 
      onClose={onClose}
    >
      <Modal.Header>Пересоздать слоты?</Modal.Header>
      <Modal.Body>
        <Checkbox 
          checked={replaceCreated} 
          onChange={(_, checked) => setReplaceCreated(checked)} 
        >
          Пересоздать существующие слоты
        </Checkbox>

        <ButtonGroup justified className='my-10'>
          <Button onClick={onClose}>Отмена</Button>
          <Button
            onClick={handleSave}
            color="green"
            appearance="primary"
            disabled={loading}
          >
            Пересоздать
          </Button>
        </ButtonGroup>
      </Modal.Body>
    </Modal>
  )
}